<script>
const models = window.models

import { selection, activeStep } from './lib.js';
if(!$selection.interiorChoices) {
    $selection.interiorChoices = {};
}
for( let [k, v] of Object.entries($selection.interior)) {
    if(!$selection.interiorChoices[k]) {
        $selection.interiorChoices[k] = v[0];
    }
}

</script>
<h2 class="byo-heading -interior">Choose Your Interior Décor Package</h2>

<div class="decor-modal__container -byo">
	<div class="decor-modal__inner -byo">
        <div class="model-decor-options__content">
            {#each Object.entries($selection.interior) as [name, options]}
                <div class="model-decor-options__image-section active">
                    {#each $selection.interiorChoices[name].swatches as swatch}
                    <div class="model-decor-options__option-wrapper">
                        <img src="{swatch.image}" alt="Shadow" class="model-decor-options__image">
                        <h4 class="model-decor-options__image-title">{swatch.name}</h4>
                    </div>
                    {/each}
                </div>
            {/each}
        </div>
        <div class="decor-modal__options">
            {#each Object.entries($selection.interior) as [name, options]}
                <div class="decor-modal__option-group">
                    <h3 class="decor-modal__option-title">{ name }</h3>
                    {#each options as option}
                        <button on:click={() => { $selection.interiorChoices[name] = option }} class="decor-modal__option-toggle {option == $selection.interiorChoices[name] ? 'active' : ''}">
                        <img src="{option.swatches[0].image}" alt="" class="decor-modal__option-img">
                    </button>
                    {/each}
                    <span class="decor-modal__option-sample">{ $selection.interiorChoices[name].name }</span>
                </div>
            {/each}
        </div>
		<p class="decor-modal__disclaimer">
		Some features in our brochures or on our website are optional. Colors and features are visual representations. Specifications and floor plans are subject to change at Tiffin’s discretion, without prior notice or obligation.
		</p>
    </div>
</div>


<div class="continue-bar js-continue-bar -active">
    <button class="continue-bar__text button -back js-forward" on:click="{() => { $activeStep = 2; window.scrollTo(0,0);}}">Prev</button>
    <button disabled={!$selection.chosenFloorplan} class="continue-bar__text button -forward js-forward" on:click="{() => { $activeStep = 4; window.scrollTo(0,0);}}">Next</button>
</div>

<style>
</style>
